export const agentList = [
  { value: 'MOBILE.APP', label:'MOBILE.APP', id: 'MOBILE.APP' },
]

export const filterList = [
  { value: 'stations', label:'Plantas'},
  { value: 'company', label: 'Empresa'  },
  { value: 'isAgent', label: 'Agentes' }
]

export const ORDER_FILTER_OPTIONS = {
  STATIONS: 'stations',
  COMPANY: 'company',
  IS_AGENT: 'isAgent',
};

export const ORDERS_SEARCH_PARAMS = 'ordersSearchParams';